import { formatNumber } from '../../Pipes/numberPipes';
import {
  type FC,
} from 'react';

export type TotalsChartItem = {
  legend: string,
  value: number,
};

type TotalsChartProps = {
  items?: TotalsChartItem[],
  title: string,
  totalValue: number,
};

export const CapitalAccountsTotalsChart: FC<TotalsChartProps> = ({
  items,
  title,
  totalValue,
}) => {
  return <div className='flex flex-col gap-[0.75rem] border-b border-black-200 pb-[0.75rem] last:border-b-white-999 last:pb-0'>
    <div className='flex items-center justify-between'>
      <div className='text-font-3 font-medium text-black-800 ms:text-font-2'>
        {title}
      </div>
      <div className=' text-font-2 font-medium text-black-999 ms:text-title-4'>
        {formatNumber(totalValue, 0, true)}
      </div>
    </div>
    {items && items?.length > 0 ? <div className='flex flex-col gap-[0.5rem]'>
      {items?.map(({ legend,
        value }) =>
        value ?
          <div className='flex justify-between' key={legend}>
            <div className='pl-[0.5rem] text-font-3 font-normal text-black-800 ms:text-font-2'>{legend}</div>
            <div className='text-font-3 font-normal text-black-999 ms:text-font-1'>{formatNumber(value, 0, true)}</div>
          </div>
          : null,
      )}
    </div> : null}
  </div>;
};
